/*
 * @Author: 肖玲
 * @Date: 2023-02-17 14:59:03
 * @LastEditTime: 2023-02-17 18:31:28
 * @LastEditors: 肖玲
 * @Description: 
 * @FilePath: \p2ps_vip_web\src\router\learning-platform\learning-assessment-manage\modules\learningPlatformRouter.js
 * 学习平台
 */
const learningPlatformRouter = [
  // 知识考核
  {
    path: '/studyPlatform/assessment/list',
    name: 'studyPlatformAssessmentList',
    component: () =>
      // import(
      //   /*webpackChunkName:"studyPlatformExamPaperBankList" */
      //   '@/views/studyPlatform/assessment/List.vue'
      // ),
    import(
      /*webpackChunkName:"studyPlatformSystemSettings" */
      '@/views/learning-platform/learning-assessment-manage/learning-platform/knowledge-assessment/Page.vue'
    ),
    meta: {
      SecondaryMenu: '学习平台', //二级菜单
      title: '知识考核',
    },
  },
  // 知识考核 详情
  {
    path: '/studyPlatform/assessment/detail/:study_cycle_id',
    name: 'studyPlatformAssessmentDetail',
    component: () =>
      // import(
      //   /*webpackChunkName:"studyPlatformExamPaperBankList" */
      //   '@/views/studyPlatform/assessment/Detail.vue'
      // ),
    import(
      /*webpackChunkName:"studyPlatformExamPaperBankList" */
      '@/views/learning-platform/learning-assessment-manage/learning-platform/knowledge-assessment/Detail.vue'
    ),
    meta: {
      SecondaryMenu: '学习平台', //二级菜单
      title: '考核详情',
      breadcrumb: [{
        title: '知识考核',
        name: 'studyPlatformAssessmentList',
      }, ],
    },
  },
  // 知识考核增加编辑
  {
    path: '/studyPlatform/assessment/add-edit/:study_cycle_id/:meta_type',
    name: 'studyPlatformAssessmentAddEdit',
    component: () =>
      // import(
      //   /*webpackChunkName:"studyPlatformAssessmentAddEdit" */
      //   '@/views/studyPlatform/assessment/AddEdit.vue'
      // ),
    import(
      /*webpackChunkName:"studyPlatformAssessmentAddEdit" */
      '@/views/learning-platform/learning-assessment-manage/learning-platform/knowledge-assessment/AddEdit.vue'
    ),
    meta: {
      SecondaryMenu: '学习平台', //二级菜单
      isMoreMeta: true,
      1: {
        title: '编辑知识考核',
        breadcrumb: [{
          title: '知识考核',
          name: 'studyPlatformAssessmentList',
        }, ],
      },
      2: {
        title: '新增知识考核',
        breadcrumb: [{
          title: '知识考核',
          name: 'studyPlatformAssessmentList',
        }, ],
      },
    },
  },
  // 资料库列表
  {
    path: '/studyPlatform/data-bank/List',
    name: 'studyPlatformDataBankList',
    component: () =>
      // import(
      //   /*webpackChunkName:"studyPlatformDataBankList" */
      //   '@/views/studyPlatform/data-bank/List.vue'
      // ),
    import(
      /*webpackChunkName:"studyPlatformDataBankList" */
      '@/views/learning-platform/learning-assessment-manage/learning-platform/database/Page.vue'
    ),
    meta: {
      SecondaryMenu: '学习平台', //二级菜单
      title: '资料库',
    },
  },
  // 资料详情
  {
    path: '/studyPlatform/data-bank/detail/:study_material_id',
    name: 'studyPlatformDataBankDetail',
    component: () =>
      // import(
      //   /*webpackChunkName:"studyPlatformDataBankDetail" */
      //   '@/views/studyPlatform/data-bank/Detail.vue'
      // ),
    import(
      /*webpackChunkName:"studyPlatformDataBankList" */
      '@/views/learning-platform/learning-assessment-manage/learning-platform/database/Detail.vue'
    ),
    meta: {
      SecondaryMenu: '学习平台', //二级菜单
      title: '资料详情',
      breadcrumb: [{
        title: '资料库',
        name: 'studyPlatformDataBankList',
      }, ],
    },
  },
  // 分类设置
  {
    path: '/studyPlatform/data-bank/classificationSettings',
    name: 'studyPlatformDataBankClassificationSettings',
    component: () =>
      // import(
      //   /*webpackChunkName:"studyPlatformDataBankClassificationSettings" */
      //   '@/views/studyPlatform/data-bank/ClassificationSettings.vue'
      // ),
    import(
      /*webpackChunkName:"studyPlatformDataBankList" */
      '@/views/learning-platform/learning-assessment-manage/learning-platform/database/ClassificationSetting.vue'
    ),
    meta: {
      SecondaryMenu: '学习平台', //二级菜单
      title: '分类设置',
      breadcrumb: [{
        title: '资料库',
        name: 'studyPlatformDataBankList',
      }, ],
    },
  },
  // 增加编辑资料
  {
    path: '/studyPlatform/data-bank/add-edit/:study_material_id/:meta_type',
    name: 'studyPlatformDataBankEditAdd',
    component: () =>
      // import(
      //   /*webpackChunkName:"studyPlatformDataBankEditAdd" */
      //   '@/views/studyPlatform/data-bank/AddEdit.vue'
      // ),
    import(
      /*webpackChunkName:"studyPlatformDataBankList" */
      '@/views/learning-platform/learning-assessment-manage/learning-platform/database/AddEdit.vue'
    ),
    meta: {
      SecondaryMenu: '学习平台', //二级菜单
      isMoreMeta: true,
      1: {
        title: '编辑资料',
        breadcrumb: [{
          title: '资料库',
          name: 'studyPlatformDataBankList',
        }, ],
      },
      2: {
        title: '添加资料',
        breadcrumb: [{
          title: '资料库',
          name: 'studyPlatformDataBankList',
        }, ],
      },
    },
  },
  // 考题库列表
  {
    path: '/studyPlatform/exam-bank/List',
    name: 'studyPlatformExamBankList',
    component: () =>
      // import(
      //   /*webpackChunkName:"studyPlatformExamBankList" */
      //   '@/views/studyPlatform/exam-bank/List.vue'
      // ),
    import(
      /*webpackChunkName:"studyPlatformExamBankList" */
      '@/views/learning-platform/learning-assessment-manage/learning-platform/question-bank/Page.vue'
    ),
    meta: {
      SecondaryMenu: '学习平台', //二级菜单
      title: '题库',
    },
  },
  // 考题库详情
  {
    path: '/studyPlatform/exam-bank/detail/:study_question_id',
    name: 'studyPlatformExamBankDetail',
    component: () =>
      // import(
      //   /*webpackChunkName:"studyPlatformExamBankDetail" */
      //   '@/views/studyPlatform/exam-bank/Detail.vue'
      // ),
    import(
      /*webpackChunkName:"studyPlatformExamBankList" */
      '@/views/learning-platform/learning-assessment-manage/learning-platform/question-bank/Detail.vue'
    ),
    meta: {
      SecondaryMenu: '学习平台', //二级菜单
      title: '题目详情',
      breadcrumb: [{
        title: '题库',
        name: 'studyPlatformExamBankList',
      }, ],
    },
  },
  // 题目分类
  {
    path: '/studyPlatform/exam-bank/topicClassify',
    name: 'studyPlatformExamBankTopicClassify',
    component: () =>
      // import(
      //   /*webpackChunkName:"studyPlatformExamBankTopicClassify" */
      //   '@/views/studyPlatform/exam-bank/TopicClassify.vue'
      // ),
    import(
      /*webpackChunkName:"studyPlatformExamBankList" */
      '@/views/learning-platform/learning-assessment-manage/learning-platform/question-bank/TopicClassification.vue'
    ),
    meta: {
      SecondaryMenu: '学习平台', //二级菜单
      title: '题目分类',
      breadcrumb: [{
        title: '题库',
        name: 'studyPlatformExamBankList',
      }, ],
    },
  },
  // 题目导入
  {
    path: '/studyPlatform/exam-bank/importTopic',
    name: 'studyPlatformExamBankImportTopic',
    component: () =>
      // import(
      //   /*webpackChunkName:"studyPlatformExamBankImportTopic" */
      //   '@/views/studyPlatform/exam-bank/ImportTopic.vue'
      // ),
    import(
      /*webpackChunkName:"studyPlatformExamBankList" */
      '@/views/learning-platform/learning-assessment-manage/learning-platform/question-bank/Import.vue'
    ),
    meta: {
      SecondaryMenu: '学习平台', //二级菜单
      title: '题目导入',
      breadcrumb: [{
        title: '题库',
        name: 'studyPlatformExamBankList',
      }, ],
    },
  },
  // 考题增加编辑
  {
    path: '/studyPlatform/exam-bank/add-edit/:study_question_id/:meta_type',
    name: 'studyPlatformExamBankAddEdit',
    component: () =>
      // import(
      //   /*webpackChunkName:"studyPlatformExamBankAddEdit" */
      //   '@/views/studyPlatform/exam-bank/AddEdit.vue'
      // ),
    import(
      /*webpackChunkName:"studyPlatformExamBankList" */
      '@/views/learning-platform/learning-assessment-manage/learning-platform/question-bank/AddEdit.vue'
    ),
    meta: {
      SecondaryMenu: '学习平台', //二级菜单
      isMoreMeta: true,
      1: {
        title: '编辑题目',
        breadcrumb: [{
          title: '题库',
          name: 'studyPlatformExamBankList',
        }, ],
      },
      2: {
        title: '添加题目',
        breadcrumb: [{
          title: '题库',
          name: 'studyPlatformExamBankList',
        }, ],
      },
    },
  },
  // 考卷库列表
  {
    path: '/studyPlatform/exam-paper-bank/List',
    name: 'studyPlatformExamPaperBankList',
    component: () =>
      // import(
      //   /*webpackChunkName:"studyPlatformExamPaperBankList" */
      //   '@/views/studyPlatform/exam-paper-bank/List.vue'
      // ),
      import(
        /*webpackChunkName:"studyPlatformExamPaperBankDetail" */
        '@/views/learning-platform/learning-assessment-manage/learning-platform/examination-paper-library/Page.vue'
      ),
    meta: {
      SecondaryMenu: '学习平台', //二级菜单
      title: '考卷库',
    },
  },
  // 考卷库详情
  {
    path: '/studyPlatform/exam-paper-bank/detail/:study_paper_id',
    name: 'studyPlatformExamPaperBankDetail',
    component: () =>
      // import(
      //   /*webpackChunkName:"studyPlatformExamPaperBankDetail" */
      //   '@/views/studyPlatform/exam-paper-bank/Detail.vue'
      // ),
      import(
        /*webpackChunkName:"studyPlatformExamPaperBankDetail" */
        '@/views/learning-platform/learning-assessment-manage/learning-platform/examination-paper-library/Detail.vue'
      ),
    meta: {
      SecondaryMenu: '学习平台', //二级菜单
      title: '考卷详情',
      breadcrumb: [{
        title: '考卷库',
        name: 'studyPlatformExamPaperBankList',
      }, ],
    },
  },
  // 考卷库增加编辑
  {
    path: '/studyPlatform/exam-paper-bank/add-edit/:study_paper_id/:meta_type',
    name: 'studyPlatformExamPaperBankAddEdit',
    component: () =>
      // import(
      //   /*webpackChunkName:"studyPlatformExamPaperBankAddEdit" */
      //   '@/views/studyPlatform/exam-paper-bank/AddEdit.vue'
      // ),
      import(
        /*webpackChunkName:"studyPlatformExamPaperBankDetail" */
        '@/views/learning-platform/learning-assessment-manage/learning-platform/examination-paper-library/AddEdit.vue'
      ),
    meta: {
      SecondaryMenu: '学习平台', //二级菜单
      isMoreMeta: true,
      1: {
        title: '编辑考卷',
        breadcrumb: [{
          title: '考卷库',
          name: 'studyPlatformExamPaperBankList',
        }, ],
      },
      2: {
        title: '添加考卷',
        breadcrumb: [{
          title: '考卷库',
          name: 'studyPlatformExamPaperBankList',
        }, ],
      },
    },
  },
]
export default learningPlatformRouter